import { type FC, lazy, Suspense, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';
import { Query, initialVars } from './SellerReviewsModalQuery.ts';

import { type SellerReviewsModalQuery } from './__generated__/SellerReviewsModalQuery.graphql.ts';
import { SellerReviewInformationLoadingSection } from './SellerReviewsModalContent/SellerReviewInformationLoading.tsx';

const SellerReviewsModal = lazy(
    () => import(/* webpackChunkName: "SellerReviewsModal" */ './SellerReviewsModal.tsx')
);

export const SellerReviewsContent: FC<{
    sellerId: string | null;
    isMobileScrollContainer?: boolean;
    noTabs?: boolean;
}> = ({ isMobileScrollContainer = false, sellerId, noTabs }) => {
    const [queryReference, loadQuery] = useQueryLoader<SellerReviewsModalQuery>(Query);

    useEffect(() => {
        if (!sellerId) return;
        loadQuery({
            ...initialVars,
            sellerId,
            isMobileScrollContainer,
        });
    }, [loadQuery, sellerId, isMobileScrollContainer]);

    if (!sellerId) {
        return null;
    }

    if (!queryReference) {
        return <SellerReviewInformationLoadingSection />;
    }

    return (
        <Suspense fallback={<SellerReviewInformationLoadingSection />}>
            <SellerReviewsModal
                contentOnly
                onClose={() => {}}
                isOpen
                sellerId={sellerId}
                queryReference={queryReference}
                isMobileScrollContainer={isMobileScrollContainer}
                noTabs={noTabs}
            />
        </Suspense>
    );
};
